
import eventBus from 'EventBus';
import BaseControlView from 'BaseControlView';
import constants from "Constants";
import template from 'common-inputs/control_numeric_input.ejs';

//=====================================================================
//
// An instance of this view represents a numeric input control.
//
// Alfonso Cabral, January, 27 2016
//
//=====================================================================
class NumericInputControlView extends BaseControlView {

    initialize(opts) {
        super.initialize(opts);

        this.template = template;
        this.tagName = 'div';
        this.family = constants.CONTROL_COMMON_INPUTS;
        this.icon = 'pf-numeric-input';

        this.events = {
            'dblclick div.pf-editable' : 'handleDblClick',
            'change input[type=text]': 'updateAttributes'
        };

        this.listenTo(eventBus, 'InputThemeChange', this.themeChangeRender);
        this.listenTo( eventBus, constants.EV_UPDATE_MARGIN_FROM_FORM, this.mobileMarginChangeRender);
        return this;
    }

    updateAttributes(ev) {
        const
            propName = ev.currentTarget.name,
            propVal = ev.currentTarget.value;
        window.setTimeout(() => this.model.set(propName, propVal));
    }

    // Neighbor aligner uses this polymorphic property, looking for
    // value 'BaseStaticTextControl'
    get kind() {
        return 'BaseStaticTextControl';
    }

}

export default NumericInputControlView;
